import React, { useContext } from "react";
import Helmet from "react-helmet";
import LessonSlideShow from "@src/components/ideas/LessonSlideShow";
import { logEvent } from "@src/utils/logClient";
import { AppDataContext } from "@src/components/AppDataContext";
import { defaultNormalizeStaticQueryResult } from "@src/utils/normalize-static-query-result";
import useSearchParams from "@src/utils/useSearchParams";

const Lesson = ({ pageContext }: { pageContext: any }) => {
  const appData = useContext(AppDataContext);

  const { lesson } = pageContext;

  defaultNormalizeStaticQueryResult(lesson);

  const [iframed, watched] = useSearchParams("iframed", "watched");
  const params = {
    iframed: !!iframed,
    watched: !!watched,
  };

  return (
    <div>
      <Helmet>
        <title>{lesson.title} - Big Ideas - Classdojo</title>
        <script src="https://cdn.radiantmediatechs.com/rmp/7.11.3/js/rmp.min.js" key="rmp" />
      </Helmet>
      <LessonSlideShow
        lesson={lesson}
        params={params}
        tab={pageContext.tab}
        logEvent={logEvent}
        user={appData.data.userData}
        classes={appData.data.classes}
        shareStatus={appData.data.shareStatus}
        shareToClassStory={appData.services.shareToClassStory}
      />
    </div>
  );
};

export default Lesson;
